/* ------------------------------------------------------------------
// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
--------------------------------------------------------------------- */
function autoCompleteAddress() {
  // 郵便番号を打ち込んだら自動で住所を入力
  $.getScript("//jpostal-1006.appspot.com/jquery.jpostal.js", () => {
    $("#jsPostalCode").jpostal({
      postcode: ["#jsPostalCode"],
      address: {
        "#prefecture": "%3",
        "#city": "%4",
        "#house_number": "%5",
      },
    });
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default autoCompleteAddress;